import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLo = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 64 80",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(2 21)",
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M53.53 6a2.996 2.996 0 012.863 2.105h0l4.47 14.305a3 3 0 01.137.895h0V31c0 .552-.224 1.052-.586 1.414A1.994 1.994 0 0159 33h0-2.07a6.98 6.98 0 01-1.98 3.95A6.978 6.978 0 0150 39a6.977 6.977 0 01-4.856-1.958 6.98 6.98 0 01-2.14-4.8h0L43 8c0-.552.224-1.052.586-1.414A1.994 1.994 0 0145 6h0z",
				stroke: "#0D0E10",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#0D0E10",
				d: "M49 7h2v13h-2zM44 20h16v2H44z"
			}),
			/* @__PURE__ */ _jsx("circle", {
				fill: "#0D0E10",
				cx: 50,
				cy: 33,
				r: 2
			}),
			/* @__PURE__ */ _jsx("circle", {
				fill: "#0D0E10",
				cx: 10,
				cy: 33,
				r: 2
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M45-1c.668 0 1.274.27 1.712.709a2.42 2.42 0 01-.439 3.77h0l-3.345 2.068L43.003 33H16.929a6.98 6.98 0 01-1.98 3.95A6.978 6.978 0 0110 39a6.977 6.977 0 01-4.856-1.958 6.985 6.985 0 01-2.048-3.882h0L.956 33a1.994 1.994 0 01-1.37-.586A1.994 1.994 0 01-1 31h0V-1z",
				stroke: "#0D0E10",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#0D0E10",
				d: "M0 26h42v2H0z"
			})
		]
	})
});
export default SvgLo;
